/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/chart-no-axes-combined
 */
import { default as DefaultIcon } from '~icons/lucide/chart-no-axes-combined';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ChartNoAxesCombinedIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
